import { buildFiltrosCamposPersonalizados } from '@/modules/campos-personalizados/campos-personalizado-utils';
import { onlyNumbers, hasAnyLetter } from '@/utils/regex-utils';

const buildCampoPersonalizadoFilter = (camposPersonalizados, filterValue) => {
  if (!camposPersonalizados) {
    return '';
  }
  const filtroPersonalizado = buildFiltrosCamposPersonalizados(camposPersonalizados, filterValue);
  if (!filtroPersonalizado) {
    return '';
  }
  return ` or ${buildFiltrosCamposPersonalizados(camposPersonalizados, filterValue)}`;
};

const createDateFilter = (intialDate, finalDate, dateField) => {
  const filters = [];
  if (intialDate) filters.push(`${dateField} >= ${intialDate}`);
  if (finalDate) filters.push(`${dateField} <= ${finalDate}`);
  return filters.length ? `(${filters.join(' and ')})` : '';
};

const getDataFilters = (state) => {
  const dataCompraFilter = createDateFilter(state.dataInicial, state.dataFinal, 'dataCompra');
  const dataFaturamentoFilter = createDateFilter(state.dataFaturamentoInicial, state.dataFaturamentoFinal, 'dataFaturamento');

  const dateFilters = [dataCompraFilter, dataFaturamentoFilter].filter(Boolean);

  return dateFilters.join(' or ');
};

export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  localEntrega(state) {
    return state.localEntrega;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  dataFaturamentoInicial(state) {
    return state.dataFaturamentoInicial;
  },
  dataFaturamentoFinal(state) {
    return state.dataFaturamentoFinal;
  },
  filterBySaving(state) {
    return state.filterBySaving;
  },
  grupo(state) {
    return state.grupo;
  },
  fornecedor(state) {
    return state.fornecedor;
  },
  listOptions(state) {
    return state.listOptions;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.localEntrega,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.dataFinal,
      state.dataInicial,
      state.dataFaturamentoInicial,
      state.dataFaturamentoFinal,
      state.filterBySaving,
      state.grupo && state.grupo.length,
      state.fornecedor && state.fornecedor.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];
    const dateFilter = getDataFilters(state);
    if (dateFilter) {
      filters.push(`(${dateFilter})`);
    }
    if (state.selectedStatus && state.selectedStatus.id === 'PENDENTE_INTEGRACAO') {
      filters.push('pendenteIntegracao is true and situacao not in (\'RASCUNHO\',\'CANCELADA\',\'RECUSADA\')');
    }
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(`situacao in ('${state.selectedStatus.value.join('\',\'')}')`);
    }
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      const idFilter = !hasAnyLetter(state.searchText) ? ` or id = ${onlyNumbers(state.searchText)}` : '';

      const campoPersonalizadoFilter = buildCampoPersonalizadoFilter(
        state.camposPersonalizados,
        searchText,
      );

      filters.push(`(codigoInterno like '%${searchText}%' or chaveNotaFiscalVinculada like '%${searchText}%' or chaveNotaFiscalManual like '%${searchText}%' or numeroNotaFiscal like '%${searchText}%'${idFilter} ${campoPersonalizadoFilter})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.localEntrega && state.localEntrega.id) {
      filters.push(`(localEntrega.id = ${state.localEntrega.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id} or produto.centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id} or produto.projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.filterBySaving) {
      filters.push('(saving > 0)');
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(categoria => `(produto.categoria.id = ${categoria.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    if (state.fornecedor && state.fornecedor.length) {
      const fornecedorFilter = state.fornecedor.map(fornecedor => `(fornecedor.id = ${fornecedor.id})`);
      filters.push(`(${fornecedorFilter.join(' or ')})`);
    }

    return filters.join(' and  ');
  },
};
